import * as types from './../actionTypes';


export function showSubmitButtonSpinner() {
    return {type: types.SHOW_SUBMIT_BUTTON_SPINNER}
}

export function hideSubmitButtonSpinner() {
    return {type: types.HIDE_SUBMIT_BUTTON_SPINNER};
}


// WEBPACK FOOTER //
// ./web/src/actions/submit/submitButtonActions.js